import Home from "@/views/Protected/Home";
import Login from "@/views/Open/Login";
import BuyLeads from "@/views/Protected/BuyLeads";
import MyLeads from "@/views/Protected/MyLeads/MyLeads";
import NotFound from "@/views/Open/NotFound";
import Covid from "@/views/Protected/Help/Covid";
import Prices from "@/views/Protected/Help/Prices";
import Rebrand from "@/views/Protected/Help/Rebrand";
import Ideal from "@/views/Protected/Help/Ideal";
import Contact from "@/views/Protected/Help/Contact";
import Terms from "@/views/Protected/Help/Terms";
import Cookies from "@/views/Protected/Help/Cookies";
import Privacy from "@/views/Protected/Help/Privacy";
import Feedback from "@/views/Protected/Feedback/Feedback";
import MyLead from "@/views/Protected/MyLeads/MyLead";
import Invoices from "@/views/Protected/Administration/Invoices/Invoices";
import PaymentMethods from "@/views/Protected/Administration/PaymentMethods";
import CompanyDetails from "@/views/Protected/Administration/CompanyDetails/CompanyDetails";
import Accreditations from "@/views/Protected/Administration/CompanyDetails/Accreditations";
import LeadSettings from "@/views/Protected/Administration/LeadSettings/LeadSettings";
import Coverage from "@/views/Protected/Administration/LeadSettings/Coverage";
import LeadAlerts from "@/views/Protected/Administration/LeadSettings/LeadAlerts";
import ParentWrapper from "@/views/Protected/ParentWrapper";
import Listing from "@/views/Protected/Administration/Listing";
import UserDetails from "@/views/Protected/Administration/UserDetails";
import LeadReport from "@/views/Protected/MyLeads/LeadReport";
import ValidateEmail from "@/views/Open/ValidateEmail";
import CoverageTabs from "@/views/Protected/Administration/LeadSettings/CoverageTabs";
import ForgotPassword from "@/views/Open/ForgotPassword";
import ResetPassword from "@/views/Open/ResetPassword";
import RenewablesPricesReduction from "@/views/Protected/Content/RenewablesPriceReduction";
import OfferFinance from "@/views/Protected/Finance/OfferFinance";
import ZohoCRMIntegration from "@/views/Protected/ZohoCRMIntegration";

export const routes  = [
  {
    path: '/',
    name: 'dashboard',
    component: Home,
    meta:{
      visible: false,
      open: false,
      icon: 'house-user'
    },
  },
  {
    path: '/login',
    name: 'log-in',
    component: Login,
    meta:{
      visible: false,
      open: true,
      title: 'Sign In'
    }
  },
  {
    path: '/validate',
    name: 'validate',
    component: ValidateEmail,
    meta:{
      visible: false,
      open: true,
      title: "Validate Email"
    }
  },
  {
    path: '/buy-leads',
    name: 'buy-leads',
    component: BuyLeads,
    meta:{
      visible: false,
      open: false,
      icon: 'address-card',
      title: "Buy Leads"
    },
  },
  {
    path: '/my-leads',
    name: 'my-leads',
    component: MyLeads,
    meta:{
      visible: true,
      open: false,
      icon: 'thumbs-up',
      title: "My Leads"
    }
  },
  {
    path: '/lead/:code',
    name: 'my-lead',
    component: MyLead,
    meta:{
      visible: false,
      open: false,
      title: "Lead Details"
    },
  },
  {
    path: '/lead/report/:code',
    name: 'lead-report',
    props: true,
    component: LeadReport,
    meta:{
      visible: false,
      open: false,
      title: "Report a Lead"
    },
  },
  {
    path: '/offer-finance',
    name: 'offer-finance',
    props: true,
    component: OfferFinance,
    meta:{
      visible: false,
      open: false,
      icon: ['circle', 'pound-sign'],
      title: 'Offer Finance',
      isNew: true,
    },
  },
  {
    path: '/profile',
    name: 'profile',
    component: ParentWrapper,
    meta: {
      visible: true,
      open: false,
      icon: 'newspaper'
    },
    children: [
      {
        path: 'listing',
        name: 'listing',
        component: Listing,
        meta:{
          visible: true,
          open: false,
          title: "Company Listing"
        },
      },
      {
        path: 'reviews',
        name: 'reviews',
        component: Feedback,
        meta:{
          visible: true,
          open: false,
          title: "Customer Feedback"
        },
      },
    ],
  },
  {
    path: '/account',
    name: 'account',
    component: ParentWrapper,
    meta: {
      visible: true,
      open: false,
      icon: 'user-circle'
    },
    children: [
      {
        path: 'invoices',
        name: 'invoices',
        component: Invoices,
        meta:{
          visible: true,
          open: false,
          title: "Invoices"
        },
      },
      {
        path: 'payment-methods',
        name: 'payment-methods',
        component: PaymentMethods,
        meta:{
          visible: true,
          open: false,
          title: "Payment Methods"
        },
      },
      {
        path: 'user',
        name: 'user-details',
        component: UserDetails,
        meta:{
          visible: true,
          open: false,
          title: "User Details"
        },
      },
      {
        path: 'company',
        name: 'company-details',
        component: CompanyDetails,
        meta:{
          visible: true,
          open: false,
          title: "Company Details"
        },
      },
      {
        path: 'accreditations',
        name: 'accreditations',
        component: Accreditations,
        meta:{
          visible: true,
          open: false,
          title: "Accreditations"
        },
      },
     {
        path: '/zoho-auth',
        name: 'zoho-auth',
        component: ZohoCRMIntegration,
        meta:{
          visible: false,
          open: false,
          title: "Zoho CRM Integration"
        },
      },
    ]
  },
  {
    path: '/settings',
    name: 'settings',
    component: ParentWrapper,
    meta:{
      visible: false,
      open: false,
      icon: 'cog'
    },
    children: [
      {
        path: 'lead-delivery',
        name: 'lead-delivery',
        component: LeadSettings,
        meta:{
          visible: true,
          open: false,
          title: "Lead Settings"
        },
      },
      {
        path: 'coverage',
        name: 'lead-selection-&-coverage',
        component: Coverage,
        meta:{
          visible: true,
          open: false,
          title: "Coverage"
        },
        children: [
          {
            path: '',
            component: CoverageTabs,
            name: 'lead-selection-&-coverage-tab-0',
            meta:{
              visible: true,
              open: true,
              title: "Coverage"
            },
          },
          {
            path: ':step',
            name: 'lead-selection-&-coverage-tab',
            component: CoverageTabs,
            meta:{
              visible: true,
              open: true,
              title: "Coverage"
            },
          },
        ],
      },
      {
        path: 'lead-alerts',
        name: 'lead-alerts',
        component: LeadAlerts,
        meta:{
          open: false,
          title: "Lead Alerts",
        },
      },
    ],
  },
  {
    path: '/help',
    name: 'help',
    component: ParentWrapper,
    meta:{
      visible: true,
      open: false,
      icon: 'question-circle'
    },
    children: [
      {
        path: 'contact',
        name: 'contact',
        component: Contact,
        meta:{
          visible: true,
          open: false,
          title: "Contact"
        },
      },
      {
        path: '/terms',
        name: 'tnc',
        component: Terms,
        meta:{
          visible: true,
          open: true,
          text: 'T&Cs',
          title: "Terms and Conditions"
        },
      },
      {
        path: '/privacy',
        name: 'privacy-policy',
        component: Privacy,
        meta:{
          visible: true,
          open: true,
          text: 'Privacy Policy',
          title: "Privacy Policy"
        },
      },
    ]
  },
  {
    path: '/content/',
    name: 'content',
    component: ParentWrapper,
    meta:{
      visible: false,
      open: false,
    },
    children: [
      {
        path: '/renewables-price-reductions',
        name: 'renewables-price-reductions',
        component: RenewablesPricesReduction,
        meta: {
          visible: true,
          open: false,
          text: 'Renewables price reductions',
          title: "Renewables price reductions"
        },
      }
    ]
  },
  {
    path: '/prices',
    name: 'prices',
    component: Prices,
    meta:{
      visible: false,
      open: false,
      title: "Prices"
    }
  },
  {
    path: '/rebrand',
    name: 'rebrand',
    component: Rebrand,
    meta:{
      visible: false,
      open: false,
      title: "Rebrand"
    }
  },
  {
    path: '/ideal-rewards',
    name: 'ideal-rewards',
    component: Ideal,
    meta:{
      visible: false,
      open: false,
      title: "More Benefits With Leads.io & Ideal Heating"
    }
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: Privacy,
    meta:{
      visible: false,
      open: false,
      title: "Privacy Policy"
    }
  },
  {
    path: '/cookies',
    name: 'cookies',
    component: Cookies,
    meta:{
      visible: false,
      open: false,
      title: "Cookies"
    }
  },
  {
    path: '/covid-19',
    name: 'covid',
    component: Covid,
    meta:{
      visible: false,
      open: false,
      title: "Coronavirus"
    }
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: ForgotPassword,
    meta: {
      visible: false,
      open: true,
      title: "Forgot Password"
    }
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: ResetPassword,
    meta: {
      visible: false,
      open: true,
      title: "Reset Password"
    }
  },
  {
    path: "*",
    name: "not-found",
    component: NotFound,
    meta: {
      visible: false,
      open: true,
      title: "Page Not Found"
    }
  }
];
